export default __webpack_public_path__ + "static/media/chartres2.d1595302.jpg";